import { createFileRoute, Link, Outlet, stripSearchParams } from "@tanstack/react-router";
import { getLesdag, isoWeekday, parseDateParam } from "#/modules/les.planning/domain/calendar";
import { RoosterRouteDialog, roosterRouteOptions } from "#/modules/les.planning/rooster-route";
import { ROOSTER_SEARCH_DEFAULTS, roosterSearchSchema } from "#/modules/les.planning/schema.search";

// Edits the rooster in the lesweek's planning runtime, so its undo covers them too.
export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lessons/week/rooster",
)({
  ...roosterRouteOptions,
  validateSearch: roosterSearchSchema,
  search: { middlewares: [stripSearchParams(ROOSTER_SEARCH_DEFAULTS)] },
  component: Rooster,
});

function Rooster() {
  const params = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RoosterRouteDialog
      params={params}
      // It opens on the weekdag of the day that is chosen, or today's.
      weekdag={search.weekdag ?? isoWeekday(getLesdag(parseDateParam(search.date)))}
      onWeekdagChange={(weekdag) =>
        void navigate({ search: (prev) => ({ ...prev, weekdag }), replace: true })
      }
      weekoverzicht={
        <Link
          to="/$locale/{-$schoolyear}/$school/lessons/week/rooster/week"
          params={params}
          search={true}
        />
      }
      vakanties={
        <Link
          to="/$locale/{-$schoolyear}/$school/lessons/week/rooster/vakanties"
          params={params}
          search={true}
        />
      }
      onClose={() =>
        void navigate({
          to: "..",
          search: ({ date, view, docenten }) => ({ date, view, docenten }),
          replace: true,
          resetScroll: false,
          viewTransition: true,
        })
      }
    >
      <Outlet />
    </RoosterRouteDialog>
  );
}
